export default "__VITE_ASSET__BmlsXh5z__"